import { jsxs as r, Fragment as e, jsx as C } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ r(e, { children: [
  /* @__PURE__ */ C(
    "path",
    {
      d: "M6 1C4.34315 1 3 2.34315 3 4V21C3 22.1046 3.89543 23 5 23H18C19.6569 23 21 21.6569 21 20V9.5H16.5C14.2909 9.5 12.5 7.70914 12.5 5.5V1H6ZM17.7456 13.4632C18.0848 13.1285 18.0848 12.5858 17.7456 12.251C17.4065 11.9163 16.8567 11.9163 16.5176 12.251L10.7632 17.9306L8.48249 15.6797C8.14335 15.3449 7.59349 15.3449 7.25435 15.6797C6.91522 16.0144 6.91522 16.557 7.25435 16.8918L10.1491 19.7489C10.3119 19.9097 10.5329 20 10.7632 20C10.9935 20 11.2144 19.9097 11.3772 19.7489L17.7456 13.4632Z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ),
  /* @__PURE__ */ C("path", { d: "M16.5 7.5C15.3954 7.5 14.5 6.60457 14.5 5.5V1.01758C17.9675 1.2623 20.7377 4.03251 20.9824 7.5H16.5Z", fill: "currentColor" })
] });
export {
  t as default
};
